<p-dialog
  [visible]="visible()"
  (visibleChange)="visibleChange.emit($event)"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [closeIcon]="'pi pi-times-circle'"
  appendTo="body"
  styleClass="update-production-task-dialog"
  [style]="{ width: '35rem' }"
  header="Would you like to update your production task?"
  (onHide)="close()">
  <div class="task-note-box d-flex align-items-center gap-3">
    <div class="task-note-field">
      <input
        pInputText
        type="text"
        class="task-note-input"
        [(ngModel)]="editableTaskTitle" />
    </div>

    <div class="task-due-date-field">
      <p-datePicker
        [(ngModel)]="editableDueDate"
        [showIcon]="true"
        [iconDisplay]="'input'"
        appendTo="body"
        dateFormat="mm/dd"
        styleClass="task-due-date-picker">
      </p-datePicker>
    </div>
  </div>

  <div
    class="task-status-row d-flex align-items-center justify-content-between">
    <p-button
      [label]="latestLineStatusLabel()"
      [styleClass]="
        isTaskUpdated() ? 'status-badge status-badge-updated' : 'status-badge'
      "
      severity="primary" />

    <p-button
      severity="info"
      styleClass="update-task-btn"
      [label]="isUpdating() ? 'Updating...' : 'Update Task'"
      [disabled]="isUpdating()"
      (click)="onUpdateTask()" />
  </div>
</p-dialog>
